import React, { useEffect } from 'react';
import Chart, { Props as ApexProps } from 'react-apexcharts';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { defaultMembers } from '../utils/options';
import { useLazyGetMembersQuery } from '../service/members.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const ActiveMembersChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getMembers,
        { data: members = defaultMembers, isFetching, isLoading },
    ] = useLazyGetMembersQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };
            getMembers(payload, true);
        }
    }, [filters]);

    const options: ApexProps['options'] = {
        labels: ['Все', 'Активные'],
        legend: {
            show: true,
            position: 'bottom',
        },
        theme: {
            monochrome: {
                enabled: true,
                color: '#597EF7',
            },
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
            },
        },
    };

    const loading = isLoading || isFetching;

    return (
        <ChartWrapper isLoading={loading} title='Активные участники'>
            <Chart
                height={'230px'}
                type='pie'
                options={options}
                series={[members.totalMembers, members.activeMembers.value]}
            />
        </ChartWrapper>
    );
};
